import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RECEPTION_MODULE_NAMESPACE, RECEPTION_GET_RECEPTIONS, RECEPTION_SET_LOADER_STATE, RECEPTION_LOADERS, RECEPTION_SET_VALUE_BY_FIELD } from '../../../../store/reception/reception-types.store';
import { IReceptionSectionListingViewModel, IReceptionDetailViewModel, IReceptionListingViewModel } from '../../../../models/reception';
import { ActivityStatus } from '../../../../common/enums';


const ReceptionStore = namespace(RECEPTION_MODULE_NAMESPACE)

@Component({
  components: {
    'sub-navigation-title': async () => import('@/components/sub-navigation-title/SubNavigationTitle.vue'),
    'reception-sidebar-loader': async () => import('../../loaders/reception-sidebar-loader/ReceptionSidebarLoader.vue')
  }
})
class MHReceptionSidebar extends Vue {

  dtMenu: boolean;
  /**
   *
   */
  constructor() {
    super();
    this.dtMenu = false;
  }
  @ReceptionStore.Getter receptionsSource: {
    activityStatus: ActivityStatus,
    data: IReceptionListingViewModel[]
  };
  @ReceptionStore.Getter receptionSource: {
    activityStatus: ActivityStatus
    detail: IReceptionDetailViewModel
  }
  @ReceptionStore.Getter receptionSections: {
    activityStatus: ActivityStatus
    data: IReceptionSectionListingViewModel[]
  }

  @ReceptionStore.Getter loaders: Map<string,boolean>

  @ReceptionStore.Action(RECEPTION_GET_RECEPTIONS)
  storeGetReceptions: () => Promise<any>;

  @ReceptionStore.Mutation(RECEPTION_SET_LOADER_STATE)
  storeSetLoaderState: (payload: { key: string, value: boolean }) => void

  @ReceptionStore.Mutation(RECEPTION_SET_VALUE_BY_FIELD)
  storeAssignValueForReceptionParameter: (value: { [x: string]: any }) => void;


  get receptionPdfReport(): string {
    return this.receptionSource.detail.pdf_report
  }
  get receptionName(): string {
    return this.receptionSource.detail.name;
  }
  get coReceptionSections() {
    return this.receptionSections.data
  }
  get receptions(): IReceptionSectionListingViewModel[] {
    return this.receptionsSource.data
  }

  get coLoader(): boolean {
    return this.loaders.get(RECEPTION_LOADERS.SIDEBAR)
  }

  beforeMount(){
    if(this.$route.path.includes('/vehicle-check'))
    {
      this.storeAssignValueForReceptionParameter({type:'vehicle'})
    } else {
      this.storeAssignValueForReceptionParameter({type:null})
    }
  }

  mounted(){
    this.storeSetLoaderState({ key: RECEPTION_LOADERS.SIDEBAR, value: true })
    this.storeGetReceptions()
       .finally(()=>{
          this.storeSetLoaderState({ key: RECEPTION_LOADERS.SIDEBAR, value: false })
       })

  }

  handleOnClickReception({ data, index }) {
    const receptionId: string = data.id.toString();
    if (this.$route.params.id !== receptionId) {
      this.$router.push({ path: `/reception/${receptionId}`, params: { id: receptionId } });
      this.dtMenu = false;
    }
  }

  _clearTimeout: any
  handleGoBack() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => this.$router.push({ path: '/reception' }), 100);
  }

  handleViewPdf() {
    if (this.receptionPdfReport !== null && this.receptionPdfReport !== undefined)
      window.open(this.receptionPdfReport)
  }
}

export default MHReceptionSidebar;



// WEBPACK FOOTER //
// ./src/containers/mh-reception/components/mh-reception-sidebar/index.ts